import * as React from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import { useMutation } from 'react-query'
import { Icon, Toast } from 'antd-mobile'
import ImageUploading from 'react-images-uploading'
import { PhotoConsumer, PhotoProvider } from 'react-photo-view'
import { paramsUploadFile, uploadFile } from '@feedback/services'
import { getTextByKey } from '@feedback/utils/util'
import styles from './index.module.scss'
import { getAppConfig } from '@feedback/utils/CONST'
import clsx from 'clsx'

export interface OSSImage {
  expires_in: number
  upload_key: string
}

// 图片上传
export const updateImage = async (
  imageList: paramsUploadFile
): Promise<OSSImage> => {
  const res = (await uploadFile(imageList)) || {}
  let msg = getTextByKey('Image uploading failed')
  if (res?.code !== 0) {
    // 图片审核
    if (res?.code === 160001) {
      msg = getTextByKey('Image reviewing failed')
      return Promise.reject(new Error(msg))
    }
    msg += res?.message ? ` ${res?.message}` : ''
    return Promise.reject(new Error(msg))
  }
  return res?.data
}

interface IFormItemProps {
  className?: string
  limit?: number
  httpResponse?: (value: any) => void
}

const FormItemImages: React.FC<IFormItemProps & ControllerRenderProps> = ({
  limit,
  value = [],
  onChange,
  httpResponse
}) => {
  const { appid } = getAppConfig() || {}

  const ImageUpload = useMutation(updateImage, {
    useErrorBoundary: false,
    onSuccess: async (data: any) => {
      if (data?.upload_key && httpResponse) {
        httpResponse(data.upload_key)
      }
    },
    onError: async (err: Error) => {
      Toast.info(
        `${err?.message}`
      )
    }
  })

  return (
    <ImageUploading
      multiple
      maxNumber={limit || 9}
      acceptType={['jpg', 'jpeg', 'png', 'gif']}
      value={value}
      onChange={(imageList) => {
        if (imageList.length > 0) {
          ImageUpload.mutate(
            { files: imageList },
            {
              onSuccess: async () => {
                onChange(imageList)
              }
            }
          )
        } else {
          onChange(imageList)
        }
      }}
      onError={(errors, files) => {
        if (errors?.maxNumber) {
          Toast.info(
            getTextByKey(
              'You can only upload a maximum of {limit} images'
            ).replace('{limit}', limit)
          )
        }
        if (errors?.acceptType) {
          Toast.info(
            getTextByKey('Please check if the image format is .JPG or .PNG')
          )
        }
      }}
    >
      {({ imageList, onImageUpload, onImageRemove, isDragging, dragProps }) => (
        <div
          className={clsx(
            styles['form-image-upload'],
            ImageUpload.isLoading && styles.loading,
            styles?.[appid]
          )}
        >
          <PhotoProvider>
            {imageList.map((image, index) => (
              <div className='item' key={index}>
                <PhotoConsumer key={index} src={image.dataURL as string}>
                  <img src={image.dataURL} alt='' />
                </PhotoConsumer>
                <i className='close' onClick={() => onImageRemove(index)} />
              </div>
            ))}
          </PhotoProvider>

          {limit && imageList?.length < limit && (
            <div
              className={`add ${isDragging ? 'is-dragging' : ''}`}
              style={isDragging ? { color: 'blue' } : undefined}
              onClick={() => {
                if (!ImageUpload.isLoading) onImageUpload()
              }}
              {...dragProps}
            >
              <i className='icon' />
            </div>
          )}
        </div>
      )}
    </ImageUploading>
  )
}

export default FormItemImages
